var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffordMainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21875 12.7991L7.95526 9.2425L11.0767 11.6945L13.7546 8.23828",
    stroke: "#2A38A4",
    strokeWidth: 1.37139,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.876,
    cy: 3.12507,
    r: 1.75739,
    stroke: "#2A38A4",
    strokeWidth: 1.37139,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2398 2.1377H5.59519C2.84194 2.1377 1.13477 4.08756 1.13477 6.84081V14.2302C1.13477 16.9835 2.80847 18.925 5.59519 18.925H13.4616C16.2148 18.925 17.922 16.9835 17.922 14.2302V7.79482",
    stroke: "#2A38A4",
    strokeWidth: 1.37139,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffordMainIcon);
export default __webpack_public_path__ + "static/media/affordMainIcon.f7a21d93f93e19885f9cee71ce1a8bc4.svg";
export { ForwardRef as ReactComponent };